import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { UIText2 } from '../../../../typography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SuggestionMobileDefaultItem = /*#__PURE__*/React.forwardRef(function (props, iconRef) {
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles['item'], props.isSelected && styles['item-selected']),
    role: "option",
    tabIndex: -1,
    onClick: props.onClick,
    onMouseMove: props.onMouseMove,
    onMouseLeave: props.onMouseLeave,
    onMouseEnter: props.onMouseEnter,
    "data-testid": "suggesttion-mobile-default-item",
    children: [props.leftIcon && /*#__PURE__*/_jsx("div", {
      ref: iconRef,
      className: styles['left-icon'],
      children: props.leftIcon
    }), /*#__PURE__*/_jsxs("div", {
      className: clsx(styles['text-area']),
      style: {
        marginLeft: props.iconMargin
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: props.children
      }), props.subtitle && /*#__PURE__*/_jsx("div", {
        className: styles['subtitle'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "gray60_100",
          children: props.subtitle
        })
      })]
    })]
  });
});
SuggestionMobileDefaultItem.displayName = 'SuggestionMobileDefaultItem';